import { removeBlackBars, centerAlignment } from './resizeHelpers';
import { carousels, carousels_mobile } from '../../sections/INF-HeroCarousel/carousel';

const resizeVideo = (container) => {
  const player = container.querySelector('[data-video-player]');
  const poster = container.querySelector('[data-video-poster]');
  const containerWidth = container.offsetWidth;
  const containerHeight = container.offsetHeight;
  const screenRatio = containerWidth / containerHeight;
  const aspectRatio = container.dataset.aspectRatio;
  const crop = container.dataset.crop === 'true';
  let videoWidth = containerWidth;
  let videoHeight = containerHeight;

  if (crop && screenRatio <= aspectRatio) {
    videoWidth = containerHeight * aspectRatio;
  } else {
    videoHeight = containerWidth / aspectRatio;
  }

  let resizedVideo = removeBlackBars({
    original_width: videoWidth,
    original_height: videoHeight,
    crop,
    screen_ratio: screenRatio,
    aspect_ratio: aspectRatio,
  });

  if (crop) {
    resizedVideo = centerAlignment({
      video: resizedVideo,
      container_width: containerWidth,
      container_height: containerHeight,
    });
  }

  player.style.width = `${resizedVideo.width}px`;
  player.style.height = `${resizedVideo.height}px`;
  player.style.margin = `${resizedVideo.margin_top}px ${resizedVideo.margin_left}px`;

  if (poster.dataset.videoPoster === 'vimeo') {
    poster.style.width = `${resizedVideo.width}px`;
    poster.style.height = `${resizedVideo.height}px`;
    poster.style.margin = `${resizedVideo.margin_top}px ${resizedVideo.margin_left}px`;
    poster.style.backgroundSize = 'contain';
  }

  if (poster.dataset.videoPoster === 'youtube' && crop) {
    poster.style.width = `${videoWidth}px`;
    poster.style.height = `${videoHeight}px`;

    if (videoWidth > containerWidth) {
      poster.style.margin = `0 ${(containerWidth - videoWidth) / 2}px`;
    }

    if (videoHeight > containerHeight) {
      poster.style.margin = `${(containerHeight - videoHeight) / 2}px 0`;
    }
  }

  // Carousel itself has to be resized if we're not cropping since the height of the slides change dynamically
  if (!crop) {
    const carousel = container.closest('[data-hero-carousel]');
    if (carousel) {
      const sectionId = carousel.parentElement.parentElement.dataset.sectionId;

      // Guard each map independently — a section can init one and bail on the
      // other (the <2-slide bail), so keying both off `carousels` would throw.
      if (carousels[sectionId]) {
        carousels[sectionId].resize();
      }
      if (carousels_mobile[sectionId]) {
        carousels_mobile[sectionId].resize();
      }
    }
  }
};

export default function () {
  const videoContainers = document.querySelectorAll('[data-background-video]');
  videoContainers.forEach((container) => {
    resizeVideo(container);
  });
}

export { resizeVideo };
